import axios from 'axios';

export default {
  state: {
    loyalty: {},
    loyaltyLoading: false,
    loyaltyError: null,
    loyaltyLoaded: false
  },
  mutations: {
    SET_LOYALTY(state, product) {
      state.loyalty = product;
      state.loyaltyLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_LOYALTY_LOADING(state, status) {
      state.loyaltyLoading = status;
    },
    SET_LOYALTY_ERROR(state, error) {
      state.loyaltyError = error;
    },
    UNSET_LOYALTY(state) {
      state.loyaltyLoaded = false;
      state.loyaltyLoading = false;
      state.loyalty = [];
    },
  },
  actions: {
    async fetchLoyalty({ commit, state }) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_LOYALTY_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/loyalty/');
        commit('SET_LOYALTY', response.data.data);
        commit('SET_LOYALTY_ERROR', null);
      } catch (error) {
        commit('SET_LOYALTY_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_LOYALTY_LOADING', false);
      }
    }
  },
  getters: {
    loyalty: state => state.loyalty,
    loyaltyLoading: state => state.loyaltyLoading,
    loyaltyError: state => state.loyaltyError,
    loyaltyLoaded: state => state.loyaltyLoaded
  }
}